import React from 'react';

import IconError from '../Images/Rebranding/IconError';

interface FieldErrorProps {
  children: React.ReactNode;
}

const FieldError = ({ children }: FieldErrorProps) => {
  return (
    <div className="mt-8 flex items-center font-suisse-screen text-disclosure-sm text-primary-magenta">
      <IconError className="mr-8 w-[15px]" />
      {children}
    </div>
  );
};

export default FieldError;
